import React from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CartProduct from '../CartProduct';
import { getProductDiscountTiers } from '../../helpers';

const CartProducts = ({ readOnly }) => {
  const { t } = useTranslation();
  const commerce = useSelector((state) => state.get('commerce'));

  if (commerce.getIn(['cart', 'products'], Immutable.List()).count() === 0) {
    return <div className="Cart__products__empty">{t('cart.empty')}</div>;
  }

  return commerce
    .getIn(['cart', 'products'], Immutable.List())
    .map((product) => {
      const discountTiers = getProductDiscountTiers(product);

      return (
        <CartProduct
          key={product.get('id')}
          id={product.get('id')}
          title={product.getIn(
            [
              'relationships',
              'purchased_entity',
              'relationships',
              'product_id',
              'attributes',
              'title',
            ],
            product.getIn(['attributes', 'title'], ''),
          )}
          type={product.getIn(
            ['relationships', 'purchased_entity', 'type'],
            '',
          )}
          price={
            readOnly
              ? product.getIn(['attributes', 'total_price', 'formatted'])
              : product.getIn(['attributes', 'unit_price', 'formatted'])
          }
          priceNumber={
            parseFloat(product.getIn(['attributes', 'unit_price', 'number'])) ||
            0
          }
          quantity={parseInt(product.getIn(['attributes', 'quantity'], 1))}
          maximumQuantity={
            product.getIn([
              'relationships',
              'purchased_entity',
              'attributes',
              'maximum_order_quantity',
            ]) ??
            product.getIn([
              'relationships',
              'purchased_entity',
              'attributes',
              'field_max_per_order',
            ]) ??
            500
          }
          discountTiers={discountTiers}
          readOnly={readOnly}
          body={product.getIn(
            [
              'relationships',
              'purchased_entity',
              'relationships',
              'product_id',
              'attributes',
              'body',
              'value',
            ],
            null,
          )}
          image={product.getIn([
            'relationships',
            'purchased_entity',
            'relationships',
            'product_id',
            'relationships',
            'field_image',
          ])}
          date={product.getIn([
            'relationships',
            'purchased_entity',
            'relationships',
            'product_id',
            'attributes',
            'field_date',
            'value',
          ])}
        />
      );
    });
};

export default CartProducts;
